/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */
import { LOADER_STATUS } from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
};

/* eslint-disable default-case, no-param-reassign */
const gstr6TabReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      default:
        return state;
    }
  };

export default gstr6TabReducer;
